import React from 'react';
import './LandingPage.css';

export default function Candidate() {
  return (
    <main className="container" style={{ padding: 24 }}>
      <h1>Candidate</h1>
      <p>Manage candidates (placeholder).</p>
    </main>
  );
}
